'use client';

import React from 'react';

interface State {
  hasError: boolean;
}

export default class ChunkErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    // ChunkLoadError or SyntaxError from stale chunks → trigger reload
    if (
      error?.name === 'ChunkLoadError' || error?.message?.includes('Loading chunk') ||
      error?.message?.includes('Failed to fetch dynamically imported module') ||
      error?.message?.includes('Unexpected token')
    ) {
      if (typeof window !== 'undefined') {
        // Avoid infinite reload loops — only reload once per session
        const reloaded = sessionStorage.getItem('chunk_reload');
        if (!reloaded) {
          sessionStorage.setItem('chunk_reload', '1');
          window.location.reload();
        }
      }
    }
    return { hasError: true };
  }

  componentDidCatch(error: Error) {
    console.error('[ChunkErrorBoundary] Caught error:', error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ fontFamily: 'sans-serif', textAlign: 'center', padding: '4rem', background: '#FAFAF9' }}>
          <h1 style={{ fontSize: '1.5rem', color: '#1E293B', marginBottom: '1rem' }}>Something went wrong</h1>
          <p style={{ color: '#64748b', marginBottom: '2rem' }}>The page failed to load. Please refresh.</p>
          <button
            onClick={() => {
              sessionStorage.removeItem('chunk_reload');
              window.location.reload();
            }}
            style={{ background: '#f97316', color: '#fff', border: 'none', borderRadius: '0.75rem', padding: '0.75rem 1.5rem', fontWeight: 600, cursor: 'pointer', fontSize: '0.9rem' }}
          >
            Refresh Page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
